import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Button, Grid, Typography, units } from '@hbf/dsl';

import { useIntl } from 'ha/i18n';
import { useMediaQuery } from 'ha/helpers/MediaQuery';
import { sharpSansBold } from 'ha/constants/fonts/sourceSansHeaders';

import { DisplayedPriceInfo } from 'ha/models/Listing/types';

import { PinLocation1Bold } from '@ha/icons';
import { PriceInfo } from './PriceInfo';

const useStyles = makeStyles()(theme => ({
  address: {
    fontFamily: sharpSansBold.fontFamily,
    fontSize: units.rem(1.25),
  },
  mapButton: {
    background: theme.palette.grey[100],
    marginLeft: units.rem(0.75),
    padding: units.yx(0.375, 1),
  },
  noTextTransform: {
    textTransform: 'none',
  },
  iconMap: {
    fontSize: `${units.rem(1.125)} !important`,
    color: theme.palette.secondary.dark,
  },
}));

interface Props {
  onMapBtnClick?: () => void;
  onBillsClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  street: string;
  priceInfo: DisplayedPriceInfo;
}

const ListingInfo: React.FC<Props> = ({
  onMapBtnClick,
  onBillsClick,
  street,
  priceInfo,
}) => {
  const { T } = useIntl();
  const { md } = useMediaQuery();
  const { classes, cx } = useStyles();

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Grid item>
        {onMapBtnClick ? (
          <React.Fragment>
            <Button
              variant="text"
              className={classes.noTextTransform}
              onClick={onMapBtnClick}
            >
              <Typography.H2
                className={classes.address}
                data-test-locator="Redesign/Listing/ListingInfo/street"
              >
                {street}
              </Typography.H2>
            </Button>
            <Button
              variant="text"
              className={cx(classes.mapButton, classes.noTextTransform)}
              onClick={onMapBtnClick}
              startIcon={<PinLocation1Bold className={classes.iconMap} />}
              data-test-locator="Redesign/Listing/ListingInfo/Map/Button"
            >
              {T('Map')}
            </Button>
          </React.Fragment>
        ) : (
          <Typography.H2
            className={classes.address}
            data-test-locator="Redesign/Listing/ListingInfo/street"
          >
            {street}
          </Typography.H2>
        )}
      </Grid>
      {md && <PriceInfo priceInfo={priceInfo} onBillsClick={onBillsClick} />}
    </Grid>
  );
};

export { ListingInfo };
